"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExposeUtils = (function () {
    function ExposeUtils(config) {
        var _this = this;
        this.exposed = false;
        this.exposing = false;
        this.callbackMap = new Map();
        this.disCallbackMap = new Map();
        this.config = config;
        if ('IntersectionObserver' in window
            && 'IntersectionObserverEntry' in window
            && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
            this.observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    try {
                        if (entry.intersectionRatio > 0 && entry.intersectionRatio <= 1) {
                            if (_this.config.onceExpose && _this.exposed)
                                return;
                            var callBack = _this.callbackMap.get(entry.target.className);
                            callBack === null || callBack === void 0 ? void 0 : callBack(entry.target);
                            _this.exposing = true;
                            _this.exposed = true;
                        }
                        if (entry.intersectionRatio <= 0 && _this.exposing) {
                            var disCallback = _this.disCallbackMap.get(entry.target.className);
                            disCallback === null || disCallback === void 0 ? void 0 : disCallback(entry.target);
                            _this.exposing = false;
                        }
                    }
                    catch (error) {
                        console.log('entry expose error', error);
                    }
                });
            }, {
                threshold: 0,
            });
        }
    }
    ExposeUtils.prototype.observe = function (el, callback, disCallback) {
        var _this = this;
        if (!el)
            return;
        this.el = el;
        this.callbackMap.set(el.className, callback);
        this.disCallbackMap.set(el.className, disCallback);
        if (this.observer) {
            this.observer.observe(el);
        }
        else {
            window.addEventListener('scroll', (function () {
                _this.scrollHadle = _this.throttle(_this.scrollListener.bind(_this), 200);
                return _this.scrollHadle;
            })(), true);
        }
    };
    ExposeUtils.prototype.unObserve = function (el) {
        if (!el)
            return;
        if (this.observer) {
            this.observer.unobserve(el);
        }
        else {
            window.removeEventListener('scroll', this.scrollHadle, true);
        }
    };
    ExposeUtils.prototype.scrollListener = function () {
        var offset = this.el.getBoundingClientRect();
        var offsetTop = offset.top;
        var offsetBottom = offset.bottom;
        if (offsetTop <= window.innerHeight && offsetBottom >= 0 && !this.exposing) {
            if (this.config.onceExpose && this.exposed)
                return;
            this.exposed = true;
            this.exposing = true;
            var callBack = this.callbackMap.get(this.el.className);
            callBack === null || callBack === void 0 ? void 0 : callBack(this.el);
        }
        else if ((offsetTop > window.innerHeight || offsetBottom < 0) && this.exposing) {
            this.exposing = false;
            var disCallback = this.disCallbackMap.get(this.el.className);
            disCallback === null || disCallback === void 0 ? void 0 : disCallback(this.el);
        }
    };
    ExposeUtils.prototype.throttle = function (fn, delay) {
        var _this = this;
        var valid = true;
        return function () {
            if (!valid) {
                return false;
            }
            valid = false;
            setTimeout(function () {
                fn.apply(_this);
                valid = true;
            }, delay);
        };
    };
    return ExposeUtils;
}());
exports.default = ExposeUtils;
//# sourceMappingURL=expose.js.map